export default "__VITE_ASSET__DWD8$2Ib__"